export default [
    function () {
        return {
            restrict: 'A',
            scope: {
                visible: '=searchboxFocus',
            },
            link($scope, $element, attrs) {
                $scope.$watch('visible', (currentValue, previousValue) => {
                    const input = $element.find('input');
                    if (currentValue === true && previousValue === false) {
                        $element.addClass('visible');
                        input[0].focus();
                    }
                    else if (currentValue === false && previousValue === true) {
                        $element.removeClass('visible');
                        input.val('').triggerHandler('change');
                    }
                });
            },
        };
    },
];
